'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconCircleCheck, iconCircleCheckTag } from '@ni/nimble-components/dist/esm/icons/circle-check';
import { wrap } from '../../utilities/react-wrapper';

export type { IconCircleCheck };
export { iconCircleCheckTag };
export const NimbleIconCircleCheck = wrap(IconCircleCheck);